module.exports = __webpack_public_path__ + "static/media/csv.677ac14b.svg";